import(/* webpackMode: "eager" */ "/app/apps/tagea-web/src/app/global-error.tsx");
